import { Component } from '@angular/core';


@Component({
  selector: 'ff-mfa-success',
  templateUrl: './mfa_success.component.html',
  styleUrls: ['./mfa_success.component.scss'],
})
export class MfaSuccessComponent {

  constructor(

  ) {}
}
